<template>
  <div v-title="$route.meta.title">
    <div class="page-heading">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item to="/">首页</el-breadcrumb-item>
        <el-breadcrumb-item>财务中心设置</el-breadcrumb-item>
        <el-breadcrumb-item>{{ $route.meta.title }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <layout-panel>
      <template slot="header">
        <span class="email-notify-header">
          <span class="email-notify-title">
            <i class="el-icon-info"></i>
            <span>配置财务相关邮件的收件人与抄送人</span>
          </span>
        </span>
      </template>

      <el-form ref="form"
               :model="form"
               :rules="rules"
               size="medium"
               label-position="top"
               @submit.native.prevent="onSubmit()">
        <div v-for="group in groupList"
             :key="group.title"
             class="email-notify-group">
          <div class="email-notify-group__title">
            <span class="title-dot"></span>
            {{ group.title }}
          </div>

          <div class="email-notify-group__row">
            <div v-for="(item, idx) in group.items"
                 :key="item.key"
                 class="email-notify-col">
              <div v-if="item.description_top"
                   class="email-notify-group__desc">
                {{ item.description_top }}
              </div>
              <el-form-item :prop="item.key">
                <template slot="label">
                  <el-tag :type="idx % 2 === 1 ? 'warning' : ''"
                          size="small">{{ item.label }}
                  </el-tag>
                </template>
                <el-select v-model="form[item.key]"
                           class="width-max"
                           multiple
                           filterable
                           clearable
                           placeholder="请输入用户名搜索">
                  <el-option
                    v-for="opt in financeAdminOptions"
                    :key="opt.id"
                    :label="opt.mail_address ? `${opt.name} / ${opt.mail_address}` : opt.name"
                    :value="opt.id">
                  </el-option>
                </el-select>
              </el-form-item>
              <div v-if="item.description_bottom"
                   class="email-notify-group__desc">
                {{ item.description_bottom }}
              </div>
            </div>
          </div>
        </div>

        <div class="form-actions">
          <el-button type="primary"
                     native-type="submit">保存
          </el-button>
          <el-button @click="goBack">返回</el-button>
        </div>
      </el-form>

      <el-dialog
        title="提示"
        :visible.sync="showInvalidDialog"
        width="50%">
        <p class="invalid-tip">以下账号并非财务管理员或已离职，请确认是否继续保存：</p>
        <table class="invalid-table">
          <thead>
            <tr>
              <th>分组</th>
              <th>配置项</th>
              <th>非法账号ID</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, i) in invalidList"
                :key="i">
              <td>{{ item.title }}</td>
              <td>{{ item.label }}</td>
              <td>{{ item.ids.join('，') }}</td>
            </tr>
          </tbody>
        </table>
        <span slot="footer">
          <el-button @click="confirmSave">继续保存</el-button>
          <el-button type="primary"
                     @click="showInvalidDialog = false">取消保存</el-button>
        </span>
      </el-dialog>
    </layout-panel>
  </div>
</template>

<script>
export default {
  data () {
    return {
      form: {
        payment_email_finance_accountant_to: [],
        payment_email_finance_manager_to: [],
        receipt_email_finance_to: [],
        receipt_email_finance_cc: [],
        void_receipt_email_finance_cc: [],
        assoc_email_finance_cc: [],
        collection_email_finance_to: [],
      },
      // 平台财务管理员列表数据源（收件人/抄送人）：usertype=[5] status=[1,2]
      financeAdminOptions: [],
      // 非法账号确认弹窗
      showInvalidDialog: false,
      invalidList: [],
      // 按邮件业务类型分组，参考设计稿左右布局
      groupList: [
        {
          title: '付款财务邮件',
          items: [
            {
              key: 'payment_email_finance_accountant_to',
              label: '待会计审批收件人',
              description_bottom: '邮件发送条件：\n1.付款单处于以下状态时: 待会计审批'
            },
            {
              key: 'payment_email_finance_manager_to',
              label: '待财务经理审批收件人',
              description_bottom: '邮件发送条件：\n1.付款单处于以下状态时: 待财务经理审批'
            },
          ],
        },
        {
          title: '开票财务邮件',
          items: [
            {
              key: 'receipt_email_finance_to',
              label: '收件人',
              description_bottom: '邮件发送条件：\n1.开票单处于以下状态时: 待开票、待作废、已开票\n2.预收款开票处于以下状态时: 待抵扣'
            },
            {
              key: 'receipt_email_finance_cc',
              label: '抄送人',
              description_bottom: '邮件发送条件：\n1.开票单处于以下状态时: 待开票、待作废、已开票\n2.预收款开票处于以下状态时: 待抵扣'
            },
            {
              key: 'void_receipt_email_finance_cc',
              label: '作废/红冲发票抄送人',
              description_bottom: '邮件发送条件：\n1.开票单处于以下状态时: 已作废、已开红冲'
            },
          ],
        },
        {
          title: '关联回款邮件',
          items: [
            {
              key: 'assoc_email_finance_cc',
              label: '抄送人',
              description_bottom: '邮件发送条件：\n1.关联回款\n2.解除回款关联'
            },
          ],
        },
        {
          title: '创建回款单邮件',
          items: [
            {
              key: 'collection_email_finance_to',
              label: '收件人/抄送人',
              description_bottom: '邮件发送规则：\n1. 未指定收件人时，邮件发送至此处配置的邮箱\n2. 已指定收件人时，此处配置的邮箱自动作为抄送人',
            },
          ],
        },
      ],
    }
  },
  async created () {
    await this.loadUserOptions()
    this.getCfg()
  },
  beforeRouteEnter (to, from, next) {
    next(vm => vm.onLoad())
  },
  computed: {
    // 每个收件人/抄送人配置项都必填（多选数组不能为空）
    rules () {
      const map = {}
      this.groupList.forEach(group => {
        group.items.forEach(item => {
          map[item.key] = [
            { required: true, type: 'array', message: `请选择${item.label}`, trigger: 'change' },
          ]
        })
      })
      return map
    },
  },
  methods: {
    // 拉取平台用户列表，作为 el-select 的数据源
    loadUserOptions () {
      return request.common('getPlatformUsersIndex', {usertype: [5], status_lists: [1, 2]}).then(({data}) => {
        this.financeAdminOptions = Array.isArray(data.data) ? data.data : []
      }).catch(() => {
        this.financeAdminOptions = []
      })
    },
    onLoad () {
      Object.assign(this.$data, this.$options.data.call(this))
    },
    onSubmit () {
      this.$refs.form.validate(valid => {
        if (!valid) {
          this.$message.error('提交内容填写不正确！')
          return
        }
        const invalid = this.checkFinanceAdmins()
        if (!invalid.length) {
          this.saveCfg()
          return
        }
        this.invalidList = invalid
        this.showInvalidDialog = true
      })
    },
    // 校验所选人员是否都在财务管理员列表中（离职/非财务管理员则不在 options 中）
    // 返回 [{ title, label, ids }]，为空表示全部合法
    checkFinanceAdmins () {
      // 列表未加载成功时无法校验，直接放行
      if (!this.financeAdminOptions.length) return []
      const validIds = new Set(this.financeAdminOptions.map(o => o.id))
      const metaMap = {}
      this.groupList.forEach(group => {
        group.items.forEach(item => {
          metaMap[item.key] = { title: group.title, label: item.label }
        })
      })
      const invalid = []
      Object.keys(this.form).forEach(key => {
        const ids = this.form[key]
        if (!Array.isArray(ids)) return
        const bad = ids.filter(id => !validIds.has(id))
        if (bad.length) {
          const meta = metaMap[key] || { title: '', label: key }
          invalid.push({ title: meta.title, label: meta.label, ids: bad })
        }
      })
      return invalid
    },
    // 弹窗中点“继续保存”
    confirmSave () {
      this.showInvalidDialog = false
      this.saveCfg()
    },
    saveCfg () {
      request.common('saveFinanceEmailNotifyCfg', _.cloneDeep(this.form)).then(() => {
        this.$message.success('保存成功')
      })
    },
    getCfg () {
      request.common('getFinanceEmailNotifyCfg').then(({data}) => {
        for (const key in this.form) {
          if (Object.prototype.hasOwnProperty.call(data, key) && Array.isArray(data[key])) {
            this.form[key] = data[key]
          }
        }
      })
    },
    goBack () {
      this.$router.back()
    },
  },
}
</script>

<style lang="scss"
       scoped>
.email-notify-header {
  padding: 15px 20px;
  margin-bottom: 20px;
  border-radius: 4px;
}

.email-notify-title {
  font-size: 16px;
  font-weight: 500;
  color: #303133;

  i {
    color: #409eff;
    margin-right: 6px;
  }
}

.email-notify-subtitle {
  margin-top: 8px;
  font-size: 13px;
  color: #909399;
}

.email-notify-group {
  position: relative;
  padding: 16px 20px;
  margin-bottom: 16px;
  border: 1px solid #ebeef5;
  border-radius: 4px;
  background: #fff;

  &__title {
    display: flex;
    align-items: center;
    margin: -16px -20px 0;
    padding: 12px 20px;
    font-size: 15px;
    font-weight: 600;
    color: #303133;
    background: #e5e7edff;
    border-radius: 4px 4px 0 0;

    .title-dot {
      width: 8px;
      height: 8px;
      margin-right: 8px;
      border-radius: 50%;
      background: #409eff;
    }
  }

  &__desc {
    font-size: 13px;
    line-height: 1.5;
    color: #909399;
    white-space: pre-line;
  }

  &__row {
    position: relative;
    display: flex;
    flex-wrap: wrap;

    .email-notify-col {
      flex: 0 0 50%;
      max-width: 50%;
      padding: 0 12px;
      box-sizing: border-box;
      position: relative;
      z-index: 1;
    }

    .el-form-item {
      margin-bottom: 0;
    }
  }
}

.form-actions {
  margin-top: 10px;
}

.invalid-tip {
  margin: 0 0 8px;
  font-size: 13px;
  color: #606266;
}

.invalid-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;

  th,
  td {
    padding: 6px 10px;
    border: 1px solid #ebeef5;
    text-align: left;
  }

  th {
    background: #f5f7fa;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/finance-config/pages/FinanceEmailNotify.vue